module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_10000_50000.0d9103d6.png";